var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen-wrap"},[_c('v-app',{staticClass:"hmc-app"},[_c('v-main',{staticClass:"main-body"},[_c('v-container',{staticClass:"app-body"},[_c('div',[_c('v-btn',{attrs:{"to":{name:'GameTestingDailyGamePlay'}}},[_vm._v("Explore")])],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }